import { useQuery } from '@tanstack/react-query'
import type { AxiosResponse } from 'axios'

import { machineService } from '@/services'
import type { GetMyMachinesPayload, MyMachinesApiResponse } from '@/services/machine'

export const useMyMachines = (
  { pageNumber, pageSize, sortOrder, searchText }: GetMyMachinesPayload,
) => {
  const { data, isFetching, isError, error } = useQuery({
    queryKey: ['machines', pageNumber, pageSize, sortOrder, searchText],
    queryFn: async () => {
      let response: AxiosResponse<MyMachinesApiResponse>

      if (searchText !== '') {
        response = await machineService.searchMachinesList({
          pageNumber,
          pageSize,
          sortOrder,
          searchText,
        })
      } else {
        response = await machineService.getMachinesList({
          pageNumber,
          pageSize,
          sortOrder,
        })
      }

      return response?.data
    },
    // placeholderData: keepPreviousData,
  })

  return {
    data,
    isFetching,
    isError,
    error,
  }
}
